const firebaseConfig = {
  apiKey: "AIzaSyBfeMHX6HAJZQ_WEmsfGgZXZSO7_NXbhhk",
  authDomain: "pendaftaranpasien-1cfbe.firebaseapp.com",
  projectId: "pendaftaranpasien-1cfbe",
  storageBucket: "pendaftaranpasien-1cfbe.appspot.com",
  messagingSenderId: "876888997898",
  appId: "1:876888997898:web:2dd5fb0238cd69d8409ff3",
  measurementId: "G-XVZ622YS58",
};

export default firebaseConfig;

// const firebaseConfig = {
//   apiKey: "AIzaSyCSuzIdB2At0MrmoeIuxpB1szlZvQ4KcWk",
//   authDomain: "data-kemenpora-dummy.firebaseapp.com",
//   projectId: "data-kemenpora-dummy",
//   storageBucket: "data-kemenpora-dummy.appspot.com",
//   messagingSenderId: "106677806193",
//   appId: "1:106677806193:web:fecc09516232f07d52e7d0",
//   measurementId: "G-0GXW31V0HS",
// };

// export default firebaseConfig;
